import React from 'react';
import { Chip } from '@mui/material';

// The pill used for a skill or tech-stack tag, wherever the site lists one.
const TechChip = ({ label, ...props }) => (
    <Chip
        label={label}
        variant="outlined"
        sx={{
            mr: 1,
            mb: 1,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '4px',
            '&:hover': { borderColor: 'text.primary', backgroundColor: 'transparent' },
        }}
        {...props}
    />
);

export default TechChip;
